const Consts = {
  // customerUrl: 'http://drcdesenvolvimento.ddns.net:4403',
  // apiUrl: 'http://drcdesenvolvimento.ddns.net:3333',
  siteUrl: 'http://www.eabenergias.com.br',
  apiUrl: 'https://drcdesenvolvimento.site:3000',
};

export default Consts;
